import React, { useEffect, useState } from "react";
import arrow from "../assets/arrow-scrolltop.png";
import "./ScrollTop.scss";

export default function ScrollTop() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 500) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={"scroll-top " + (showTopBtn ? "show" : "")}
      onClick={() => goToTop()}
    >
      <img src={arrow} alt="scrolltop" />
    </button>
  );
}
